<template>
  <div>
    <div class="group">
      <div
        class="sentence-con"
        :style="{
          top: `${offsetTop}px`,
        }"
      >
        <div
          class="sentence-list"
          v-for="(sentence, index) in sentenceDataArr"
          :key="'list' + index"
        >
          <div
            :class="{
              'is-active': word.status == 'active',
              'is-right': word.status == 'right',
              'is-normal': word.status == 'normal',
              'is-active-wrong': word.status == 'active-wrong',
              'is-wrong': word.status == 'wrong',
              'is-space': word.word == ' ',
            }"
            class="sentence"
            v-for="(word, idx) in sentence"
            :key="'word' + idx"
          >
            <div>{{ word.word }}</div>
          </div>
        </div>
      </div>
    </div>
    <successDialog
      v-if="showDialog"
      @clickConfirm="clickConfirm"
      @clickClose="clickClose"
      :is-confirm-dialog="true"
      :dialog-title="'Congratulations'"
      :dialog-img="dialogImg"
    >
    </successDialog>
  </div>
</template>

<script>
import dialog from "../views/mixins/dialog";
export default {
  name: "SentenceStyle",
  props: {
    listWordData: {
      type: String,
      default:
        "Hello World Python C++ Words Excel PPT Javascript Letter Fuck Shift Ctrl",
    },
    mode: {
      type: String,
      default: "infinite",
    },
    dialogImg: {
      type: String,
      default: "",
    },
  },
  mixins: [dialog],
  mounted() {
    this.transArray();
    this.maxIndex = this.listWordData.replace(/\;/g, "").length;
    console.log(this.sentenceDataArr, "sentenceDataArr");
    this.topLimit = 65 * this.sentenceDataArr.length;
    console.log(this.topLimit);
  },
  data() {
    return {
      sentenceDataArr: [],
      nowLevel: 0,
      offsetTop: 0,
      topLimit: 0,
      nowIndex: 0,
      goBackNum: 0,
      maxIndex: 0,
      answerReport: "",
      correctNum: 0,
      wrongNum: 0,
    };
  },
  watch: {
    $route() {
      this.nowLevel = 0;
      this.offsetTop = 0;
      this.topLimit = 0;
      this.nowIndex = 0;
      this.goBackNum = 0;
      this.maxIndex = 0;
      this.answerReport = "";
      this.correctNum = 0;
      this.wrongNum = 0;
    },
  },
  methods: {
    transArray() {
      let totalArr = [];
      this.listWordData.split("").forEach((ele, index) => {
        let obj = {
          word: ele,
          status: index === 0 ? "active" : "normal",
        };
        totalArr.push(obj);
      });
      let iddddx = 0;
      for (let index = 0; index < totalArr.length; index++) {
        const element = totalArr[index];
        let reg = /\s/;
        if (reg.exec(element.word)) {
          // if (element.word === " ") {
          this.sentenceDataArr.push(totalArr.slice(iddddx, index));
          iddddx = index + 1;
        }
      }
    },
    handlerWord(key) {
      let keyActiveObj = this.sentenceDataArr[this.nowLevel][this.nowIndex];
      this.$set(keyActiveObj, "nowKey", key);
      let modeCase = {
        infiniteRight: this.mode === "infinite" && key === keyActiveObj.word,
        infiniteWrong: this.mode === "infinite" && key !== keyActiveObj.word,
        easeRight: this.mode === "ease" && key === keyActiveObj.word,
        easeWrong: this.mode === "ease" && key !== keyActiveObj.word,
      };
      let originArr = this.listWordData
        .split(" ")
        .filter((item) => item.length > 0);
      let nextKeyActiveObj = {};
      if (modeCase.infiniteRight) {
        this.$set(keyActiveObj, "status", "right");
        this.nowIndex++;
        this.isOver(originArr);
        if (this.nowIndex === originArr[this.nowLevel].length) {
          this.nowLevel++;
          this.nowIndex = 0;
          if (Math.abs(this.offsetTop) < this.topLimit - 200) {
            this.offsetTop -= 65;
          }
        }
        nextKeyActiveObj = this.sentenceDataArr[this.nowLevel][this.nowIndex];
        this.$set(nextKeyActiveObj, "status", "active");
      } else if (modeCase.infiniteWrong) {
        nextKeyActiveObj = this.sentenceDataArr[this.nowLevel][this.nowIndex];
        this.$set(keyActiveObj, "status", "active-wrong");
      } else if (modeCase.easeRight) {
        this.nowIndex++;
        this.$set(keyActiveObj, "status", "right");
        this.isOver(originArr);
        if (this.nowIndex === originArr[this.nowLevel].length) {
          this.nowLevel++;
          this.nowIndex = 0;
          if (Math.abs(this.offsetTop) < this.topLimit - 200) {
            this.offsetTop -= 65;
          }
        }
        nextKeyActiveObj = this.sentenceDataArr[this.nowLevel][this.nowIndex];
        this.$set(nextKeyActiveObj, "status", "active");
      } else {
        this.nowIndex++;
        this.isOver(originArr);
        nextKeyActiveObj = this.sentenceDataArr[this.nowLevel][this.nowIndex];
        this.$set(keyActiveObj, "status", "wrong");
      }
      // this.updateWrongNum();
    },
    isOver(originArr) {
      if (
        this.nowLevel === originArr.length - 1 &&
        this.nowIndex === originArr[originArr.length - 1].length
      ) {
        this.$emit("GAME OVER");
        console.log("Game Over");
      }
    },
    updateWrongNum() {
      this.wrongNum = 0;
      this.sentenceDataArr.forEach((item) => {
        item.forEach((obj) => {
          if (obj.status === "wrong") {
            this.wrongNum++;
          }
        });
      });
    },
    nextWord() {
      return this.sentenceDataArr[this.nowLevel][this.nowIndex - 1].word;
    },
    nextKey() {
      console.log(
        this.sentenceDataArr[this.nowLevel][this.nowIndex].word,
        "this.sentenceDataArr[this.nowLevel][this.nowIndex].word"
      );
      return (
        this.sentenceDataArr[this.nowLevel][this.nowIndex].word ||
        this.listWordData[0]
      );
    },
  },
};
</script>

<style scoped lang="less">
.group {
  margin: 0 auto;
  width: 800px;
  height: 200px;
  overflow: hidden;
  position: relative;
  margin-bottom: 15px;
  .sentence-con {
    position: absolute;
    width: 100%;
    box-sizing: border-box;
    padding: 0 200px;
    left: 0;
    height: auto;
    transition: all ease 0.5s;
    border-bottom: 7px solid #fbb000;
  }
}
.sentence-list {
  display: flex;
  flex-wrap: wrap;
  // 一截65px
  height: 30px;
  margin-bottom: 35px;
  line-height: 30px;
  font-size: 30px;
  position: relative;
  &::after {
    position: absolute;
    display: block;
    content: "";
    width: 155px;
    height: 35px;
    bottom: -35px;
    background-size: contain;
    background-repeat: no-repeat;
    background-image: url("../assets/images/tree.svg");
    transform: rotateY(180deg);
  }
  &:nth-child(odd) {
    text-align: rgiht;
    justify-content: flex-start;
    &::after {
      transform: rotateY(0deg);
    }
  }
  &:nth-child(even) {
    justify-content: flex-end;
    text-align: left;
  }
  .sentence {
    font-weight: 500;
    border-bottom: 3px solid transparent;
    display: inline-block;
  }
  .is-space {
    width: 0.5em;
  }
  .is-right {
    background: #edf7e7;
    color: #95c590;
    transition: color 0.12s ease-in-out;
  }
  .is-active-wrong {
    color: red;
    animation: breatheWrong 1.3s infinite;
  }
  .is-wrong {
    color: red;
  }
  .is-active {
    background-color: transparent;
    color: #4a4a4a;
    animation: breathe 1.3s infinite;
  }
}
@keyframes breathe {
  0% {
    color: #ffffff;
    background-color: #3295db;
  }
  50% {
    color: #3295db;
    background-color: #ffffff;
  }
  100% {
    color: #ffffff;
    background-color: #3295db;
  }
}
@keyframes breatheWrong {
  0% {
    color: #ffffff;
    background-color: #fb0000;
  }
  50% {
    color: #fb0000;
    background-color: #ffffff;
  }
  100% {
    color: #ffffff;
    background-color: #fb0000;
  }
}
</style>
